import React, { Component } from 'react'
import Select from 'react-select'
import { NotificationManager } from 'react-notifications'
import api from '../../../api/api'
import { promised, createFormData } from '../../../helpers/utility'
import {
  statusRenderer,
  ticketStatusDict,
} from './helpers'

const statusOptions = Object.keys(ticketStatusDict).map(
  key => ({ label: ticketStatusDict[key], value: key })
)

class ViewSupportTicketStatusForm extends Component {

  onUpdateFailure = (res) => {
    NotificationManager.error('اشکالی رخ داد')
  }

  onUpdateSuccess = (res) => {
    NotificationManager.success('تغییر وضعیت با موفقیت انجام شد', null, 6000)
  }

  updateTicketStatus = status => {
    const formData = {
      ticket_status: status.value
    }

    return new Promise( () => {
      return api.editSupportTicket(
          this.props.ticket.ticket_code,
          createFormData(formData),

        ).then(this.onUpdateSuccess)
        .catch(this.onUpdateFailure)
      })
  }

  handleChange = selectedOption => {
    // console.log(selectedOption)
    this.updateTicketStatus(selectedOption)
  }

  render() {
    const { ticket: { ticket_status }, status } = this.props
    const initialValue = { value: status, label: statusRenderer(status) }

    return (
      <Select
        options={statusOptions}
        onChange={ this.handleChange }
        defaultValue={initialValue}
        placeholder={'انتخاب'}
        isSearchable={false}
      />
    )
  }
}

export default ViewSupportTicketStatusForm


// WEBPACK FOOTER //
// ./src/components/common/Support/ViewSupportTicketStatusForm.js